import React, { useState } from 'react'
import Input from "../../../../../../core/Inputs/DefaultInput";
import { useDispatch } from 'react-redux';
import { changeAddSurveyFormData } from '../../../../../../store/actions/surveyAction';
import { useTranslation } from 'react-i18next';

export default function QuestionScreen4({ changeScreen }) {
    const { t, i18n } = useTranslation();
    //States
    const [sectionCount, setSectionCount] = useState('')
    const [error, setError] = useState(null)
    const dispatch = useDispatch()

    //Functionality
    const onSubmit = () => {
        if (!isSectionCountValid()) {
            return
        }
        dispatch(changeAddSurveyFormData('survey_section_count', sectionCount))
        if (Number(sectionCount) === 0)
            changeScreen('SKIP')
        else
            changeScreen('INCREMENT')
    }

    const isSectionCountValid = () => {
        if (sectionCount === '' || Number(sectionCount) === 0) {
            setError(t('survey.numberRequire'))
            return false
        }
        if (Number(sectionCount) > 20) {
            setError('Maximum 20 sections allowed')
            return false
        }
        setError(null)
        return true
    }

    return (
        <div className="new-survery-screen text-center">
            <div className="surv-question-wrap">
                <div className="text-wrapper">
                    <h2 className="question">{t('survey.ques4')}<br />
                        {/* <small>*If you have no sections enter 0</small> */}
                    </h2>
                    <div className="input-wrap mb-5 position-relative">
                        < Input
                            type='number'
                            view='outlined'
                            dense={false}
                            color='default'
                            label=''
                            placeholder={t('survey.enterNumber')}
                            value=""
                            success={false}
                            fill={true}
                            className={"formsinput"}
                            onBlur={() => isSectionCountValid()}
                            onInput={e => setSectionCount(e.target.value)}
                        />
                        {error && <div className="validation-msg">{error}</div>}
                    </div>
                    <button className='btn btn-primary next-btn' onClick={() => onSubmit()}>{t('survey.question.next')}</button>
                </div>
            </div>
        </div>
    )
}
